









































































import { computed, ref } from '@nuxtjs/composition-api';
import { defineAsyncComponent, defineComponent } from '@vue/composition-api';
import { purify } from '~/directives/purify-html';
import { MemoryGameModal, memoryGameOpen, useCartAttributes } from '~/features/cart';
import { useGiftTiers, useNextLevelAmount, useWheelGifts } from '~/features/gift-tiers';
import { useI18n } from '~/features/i18n';
import { PromotionOption } from '~/features/cart/utils';
import { useAuth } from '~/features/auth';
import { useAlerts } from '~/features/alerts';
import { useRouter } from '~/features/router';
import { topics, useChannels } from '~/features/channels';

export default defineComponent({
  directives: {
    purify,
  },
  setup() {
    const { cartPromotions, subtotalWithDiscounts, spinTheWheelData } = useCartAttributes();
    const { isLoggedIn } = useAuth();
    const { t } = useI18n();
    const viewRewards = ref(false);
    const { warn } = useAlerts();
    const { redirect } = useRouter();
    const { subscribe } = useChannels();

    const { nextLevelAmount } = useNextLevelAmount(cartPromotions);

    const { amountRemaining, currentTier, progressDone } = useGiftTiers(
      nextLevelAmount,
      subtotalWithDiscounts,
      computed(() => ({
        tiers:
          cartPromotions.value?.options?.map(option => ({
            discountValue: option?.tier_minimum_subtotal || 0,
          })) || [],
        eligibleTierIdx: cartPromotions.value.eligiblePromotionIdx,
      }))
    );

    function openGameModal() {
      if (!isLoggedIn.value) {
        if (process.browser) {
          sessionStorage.setItem('showCartFirstTime', 'true');
        }
        warn(t('loginFirst').toString());
        redirect('/login');
        return;
      }
      lazyLoadGameModal();
    }

    function lazyLoadGameModal() {
      memoryGameOpen.value = true;
      MemoryGameModal.value = defineAsyncComponent(
        () => import(/* webpackChunkName: "memory-game-modal" */ '@/components/Modal/MemoryGame.vue')
      );
    }

    const { wheelGifts } = useWheelGifts(computed(() => cartPromotions.value.options as PromotionOption[]));

    function relevantTierMessage() {
      if (currentTier.value) {
        return progressDone.value === 100 ? t('allRewardsUnlocked') : t('spendToUnlockAll', [amountRemaining.value]);
      } else {
        return t('spendToSpin', [amountRemaining.value]);
      }
    }

    /**
     * show memory game dialog after customer login and customer cart fetch,
     * showCartFirstTime used to show cart one time only after redirect to login
     */
    subscribe(topics.cart.fetchCustomerCart, () => {
      const showCartFirstTime = process.browser ? !!sessionStorage.getItem('showCartFirstTime') : false;
      if (!spinTheWheelData.value?.gift?.sku && showCartFirstTime) {
        if (process.browser) {
          sessionStorage.setItem('showCartFirstTime', '');
        }
        lazyLoadGameModal();
      }
    });

    return {
      MemoryGameModal,
      cartPromotions,
      memoryGameOpen,
      amountRemaining,
      currentTier,
      progressDone,
      viewRewards,
      wheelGifts,
      spinTheWheelData,
      isLoggedIn,
      relevantTierMessage,
      openGameModal,
    };
  },
});
